import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/image_24.svg.ts
import { svg } from "lit";
var image24Svg = svg`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.0001 17.7237L15.0001 12L6.47369 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  image24Svg
};
//# sourceMappingURL=image_24.svg-LMEQRSRL.js.map
